import axios from '@/load_axios';

const settings = {
    namespaced: true,
    state: {
        all: [],
        baseUrl: window.BASE_URL ? window.BASE_URL : process.env.VUE_APP_HOSTNAME,
    },
    getters: {
        slug: (state) => (slug) => {
            return state.all.find( category => category.slug == slug)
        },
        path: (state) => (path) => {
            let o = state.all
            for(let key of path) {
                o = o[key]
                if( o == null ) {
                    return null
                }
            }
            return o
        },
    },
    mutations: {
        setAll(state, all) {
            state.all = all
        },
    },
    actions: {
        async getAll({commit, state}) {
            if( state.all.length != 0 ) {
                return
            }
            const res = await axios.get(`${state.baseUrl}/wp-json/blat/v1/settings`)
            commit('setAll', res.data)
        },
    },
}

export default settings
